import { render } from "./SingleUserExample.vue?vue&type=template&id=459f6056&ts=true"
import script from "./SingleUserExample.vue?vue&type=script&lang=ts"
export * from "./SingleUserExample.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__